import axios from "axios";
import { getAxiosConfig } from "./api-config";

export class ApiService {
  constructor() {
    const axiosConfig = getAxiosConfig();
    this.requests = axios.create(axiosConfig);
  }

  initErrorHandling = (callback) => {
    return this.requests.interceptors.response.use(undefined, () => {
      callback();
    });
  };

  async getAppSwitcherUrl(appId) {
    return (
      await this.requests.post("/v1/appSwitchAction", {
        appId
      })
    ).data;
  }

  async getTermsAndConditions(url) {
    return (await axios.get(url)).data;
  }

  async postFeedback(url, payload) {
    return axios.post(url, payload);
  }

  async getAssistantUrl() {
    return this.requests.get("/v1/assistant/tokenUrl");
  }

  async getDrugSlug(externalId) {
    return this.requests.get(`/v1/assistant/drugSlugs/${externalId}`);
  }

  async getIsabelParams() {
    return (await this.requests.get("/v1/isabel/token/")).data;
  }
}

export default new ApiService();
